import React, {ReactNode} from 'react';

type NavbarProps = {
    children: ReactNode
}

function Navbar(props: NavbarProps) {
    return (
        <nav className={"navbar"}>
            <ul className={"navbar-list"}>{props.children}</ul>
        </nav>
    );
}

export default Navbar;
